import { ReactNode } from 'react';
import { Box, Divider, Stack, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Paper, SizingMultiplier, Typography } from '@ocx/ui';
import { CarWashIcon } from '@ocx/ui-icons';

const StyledCarWashIcon = styled(CarWashIcon)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

type CarWashProps = {
  children: ReactNode;
};

export const CarWash = ({ children }: CarWashProps) => (
  <Stack
    component={Paper}
    direction="row"
    alignItems="center"
    spacing={1}
    px={1.5}
    borderRadius={(theme) => theme.spacing(SizingMultiplier.sm)}
    outlined>
    <StyledCarWashIcon />
    <Typography flexGrow={1} variant="caption">
      <FormattedMessage
        id="receipt:carWashCodeTitle"
        defaultMessage="Car Wash Code"
        description="Receipt page: car wash code text"
      />
    </Typography>
    <Box display="flex">
      <Divider flexItem sx={{ my: -2, mx: 1 }} variant="dashed" orientation="vertical" />
      <Typography mx={2} variant="h5">
        {children}
      </Typography>
    </Box>
  </Stack>
);
